import { useSuspenseQuery } from '@tanstack/react-query';
import { assignmentsQueries } from './assignments-keys';

export function useAllAssignments() {
  const { data, isLoading, isError, error } = useSuspenseQuery(assignmentsQueries.list());

  return {
    assignments: data ?? [],
    isLoading,
    isError,
    error,
  };
}
